<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <h1>Berita Perindo</h1>
        <div class="search section-list">

          <!-- <div class="search__heading">
            <div class="group-select">
              <select class="select-css mg-right" name="" id="" v-model="featured" @change="getListPerindo">
                <option value="" selected>Select Featured :</option>
                <option value="true">Show</option>
                <option value="false">Hide</option>
              </select>
            </div>
            <div class="mg-top1 group-select">
              <select class="select-css mg-right" name="" id="" v-model="cat_id" @change="getListPerindo">
                <option value="" selected>Select Category :</option>
                <option v-for="(data,index) in listCategory" :key="index" :value="data.cat_id">{{ data.name }}</option>
              </select>
            </div>
          </div> -->

          <div class="group-btn">
            <button class="btn-add mg-right" @click="viewCat()">
              View Category
            </button>
            <!-- <button class="btn-add mg-right" @click="viewRestore()">
              View Restore
            </button> -->
            <button class="btn-add mg-right" @click="addCat()">
              Add Category
            </button>
            <button class="btn-add" @click="viewForm()">
              Add New
            </button>
          </div>
        </div>

        <div class="section-list">
          <ul class="main-post">
            <li class="list-post btm-margin">
              <p>Title</p>
              <p>Featured</p>
              <p>Author</p>
              <p>Date/Status</p>
            </li>
            <div class="list-post__item">
              <li class="list-post" v-for="(data,index) in listData" :key="index">
                <div class="list-post__title">
                  <p>{{ data.title }}</p>
                  <button class="button" @click="editData(data.news_id)">Edit</button>
                  <button class="button hov-del" @click="delData(data.news_id)">Delete</button>
                </div>
                <div>
                    <p class="main-post__author">{{ data.featured.Bool ? 'Show' : 'Hide' }}</p>
                </div>
                <!-- <div>
                  <p>{{ data.desc }}</p>
                </div> -->
                <div> 
                  <p class="main-post__author">Admin</p>
                  <p class="main-post__email">admin@gmail.com</p>
                </div>
                <div>
                  <p class="main-post__date">{{ formatDate(data.dtm_upd.Time) }}</p>
                  <p class="main-post__date">{{ data.published? '': 'not' }} published</p>
                  <button v-if="data.is_deleted.Bool == true" class="button" @click="resData(data.news_id)">Restore</button>
                </div>

              </li>
            </div>
          </ul>
          <paginate
            :page-range="3"
            :page-count="totalPages"
            :margin-pages="2"
            :click-handler="getListPerindo"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import moment from 'moment';
import axios from 'axios';

import auth from '@/service/auth.js'

export default {
  name: 'BeritaPerindo',
  data () {
    return {
      id: '',
      // featured: '',
      pageNum: 1,
      totalPages: 0,
      limit: 10,
      // cat_id: '',
      listData: [],
      listCategory: [],
      isLoading: false,
    }
  },
  methods: {
    formatDate (val) {
        let date = val.split('T')[0]
        let time = val.split('T')[1].split('Z')[0]
        let dateTime = `${date} ${time}` 
        return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
    },
    editData (id) {
      this.$router.push(`/berita-perindo/form/${id}`)
    },
    viewForm () {
      this.$router.push(`/berita-perindo/form/0`)
    },
    addCat() {
      this.$router.push(`/form-category/berita/0`)
    },
    viewCat() {
      this.$router.push(`/view-category/berita`)
    },
    // viewRestore() {
    //   this.$router.push(`/restore/berita`)
    // },
    async resData(id) {
      console.log('resId', id)
      let self = this
      alert.confirmation( async function () {
      self.isLoading = true
          try {
              const response = await axios.patch(`/content/restorenews/${id}`)
              self.isLoading = false
              console.log(response)
              alert.success('Restore data success', () => self.getListPerindo())
          } catch (error) {
              self.isLoading = false
              console.log(error)
              alert.failed('Restore data failed')
          }
      }, 'Are you sure to restore this data?')
    },
    async getListPerindo(page) {
      this.pageNum = page
      this.isLoading = true
      try {
          const response = await axios.get('/content/listnews', {
            params: {
              // featured: this.featured,
              // cat_id: this.cat_id,
              page: this.pageNum,
              limit: this.limit
            }
          })
          console.log(response)
          
          this.listData = response.data.data
          // this.listData = response.data.data.filter(item => {
          //   return item.is_deleted.Bool == false
          // })

          this.totalPages = Math.ceil(response.data.meta.total_data / this.limit)
          console.log('dataList', this.listData)
          this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async delData(id) {
      console.log('id', id)
      let self = this
      alert.confirmation( async function () {
        self.isLoading = true
        try {
            const response = await axios.delete(`/content/news/${id}`)
            self.isLoading = false
            console.log(response)
            alert.success('Delete data success', () => self.getListPerindo())
        } catch (error) {
            self.isLoading = false
            console.log(error)
            alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
    },
    async getListCatNews() {
      this.isLoading = true
      try {
          const response = await axios.get('/content/listnewscategory')
          console.log(response)

          this.listCategory = response.data.data
          console.log('dataCat', this.listCategory)
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
  },
  components: {
    Loader
  },
  async created() {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getListCatNews();
    this.getListPerindo();
  }
}
</script>